<script>
    import { menu } from "../../stores";
    import { link } from "svelte-routing";
    import { authenticated } from "../../firebase/auth";
    import LoginButton from "../auth/LoginButton.svelte";
    import AccountWidget from "./AccountWidget.svelte";
    import Fa from "svelte-fa";
    import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
</script>

<!-- <a class="left" href="/betrieb" use:link>Home</a> -->
<!-- <div class="left">
</div> -->
<div class="nav-bar">
    <button class="menu-toggle" on:click={() => $menu = !$menu}>
        {#if $menu}
            <Fa icon={faXmark}/>
        {:else}
            <Fa icon={faBars}/>
        {/if}
    </button>
    
    <div class="right">
        <div>
            {#if $authenticated}
                <AccountWidget />
            {:else if $authenticated == false}
                <LoginButton />
            {:else}
                <!-- loading state, leave blank -->
            {/if}
        </div>
    </div>
</div>

<style>
    .nav-bar {
        position: sticky;
        /* position: fixed; */
        top: 0;
        left: 0;
        right: 0;
        z-index: 10;
        padding: 0.5rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: rgba(255, 255, 255, 0.6);
        backdrop-filter: blur(10px);
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    }

    .menu-toggle {
        background-color: transparent;
        /* background-color: rgba(255, 255, 255, 0.6);
        backdrop-filter: blur(10px); */
        border-radius: 1rem;
        z-index: 10;
        line-height: 1;
        width: 2rem;
        height: 2rem;
        padding: 0;
    }

    .right {
        display: block;
        z-index: 10;
    }
</style>